import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useForm, Controller } from 'react-hook-form';
import {
  Box,
  Typography,
  Chip,
  Stack,
  Divider,
  Tabs,
  Tab,
  Button,
  Grid,
  LinearProgress,
  IconButton,
  CircularProgress,
  Card,
  Modal,
  TextField,
  InputAdornment,
  Alert,
  FormControlLabel,
  Switch,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Dialog,
  DialogContent,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Popover,
} from '@mui/material';
import dayjs from 'dayjs';
import VisibilityIcon from '@mui/icons-material/Visibility';
import api from '../../utils/functions/api';
import { EXP_STATUS_MAP } from '../../utils/constants/financeStatus.constant';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ProjectEditPopup from './ProjectEditPopup';
import _ from 'lodash';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import * as actions from '../../redux/actions';
import { DevWinBadge } from '../../components/DevPageBadge';
import { BudgetForm, DeliverForm } from '../../components/Forms';
import { CSVUploadModal } from '../../components/Modal';
import BudgetTable from '../../components/Table/BudgetTable';
import BudgetListTable from '../../components/Table/BudgetListTable';
import CheckInlist from '../../components/Table/CheckInlist';
import { ExpensesTableProject } from '../../components/Table';
import ExpensesDetail from '../Finance/ExpensesDetail';
import SaveIcon from '@mui/icons-material/Save';

const WORK_OPTIONS = [
  { key: 'waiting', label: 'รอเข้าดำเนินการ', color: '#64748b' },
  { key: 'in_progress', label: 'ดำเนินการ', color: '#2563eb' },
  { key: 'done', label: 'เสร็จ 100%', color: '#059669' },
];
const FINANCE_OPTIONS = [
  { key: 'none', label: 'ยังไม่เคยเบิก', color: '#94a3b8' },
  { key: 'partial', label: 'เบิกแล้วบางส่วน', color: '#f59e0b' },
  { key: 'billed_waiting', label: 'วางบิลแล้วรอรับเงิน', color: '#d97706' },
  { key: 'last_installment', label: 'รอรับงวดสุดท้าย', color: '#c2410c' },
  { key: 'completed_po', label: 'รับเงิน100%แล้ว', color: '#059669' },
];
const BG_USAGE_OPTIONS = [
  { key: 'no_bg_usage', label: 'ไม่ใช้ BG แล้ว', color: '#374151' },
];
const LEGAL_OPTIONS = [
  { key: 'legal_warranty', label: 'Warrant/Guarantee', color: '#7c3aed' },
  { key: 'legal_debt', label: 'เจ้าหนี้ค้างจ่าย', color: '#dc2626' },
  { key: 'legal_lawsuit', label: 'ฟ้องร้อง', color: '#991b1b' },
];
function computeHasCommitment(d) {
  return (
    d.work_status !== 'done' ||
    d.finance_status !== 'completed_po' ||
    d.legal_warranty ||
    d.legal_debt ||
    d.legal_lawsuit
  );
}

const fmt = (n) =>
  n != null
    ? `${Number(n)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
    : '0.00';
const fmtPct = (num, den) =>
  den ? `${((num / den) * 100).toFixed(1)}%` : null;

const STATUS_MAP = {
  PENDING: { label: 'รอดำเนินการ', color: 'warning' },
  IN_PROGRESS: { label: 'กำลังดำเนินการ', color: 'info' },
  DELIVERY: { label: 'งาน100%รอรับเงินงวดสุดท้าย', color: 'warning' },
  Warranty: { label: 'มีWarrant/Guarantee', color: 'secondary' },
  WAITING_PAYMENT: { label: 'รอรับชำระเงิน', color: 'error' },
  ELIGIBLE_FOR_CLOSE: { label: 'พร้อมปิดงาน', color: 'info' },
  COMPLETED: { label: 'ไม่มีภาระผูกพัน', color: 'success' },
  COMPLETE: { label: 'ปิดงาน', color: 'default' },
};

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 1000,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

export default function ProjectPopup({
  propId,
  onClose,
  onSaved,
  initialData,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const id = propId;

  const project = useSelector((state) => state.project);
  const budget = useSelector((state) => state.budget);
  const timestamp = useSelector((state) => state.timestamp);
  const info = useSelector((state) => state.info);
  const me = useSelector((state) => state.me);

  const [cachedProject, setCachedProject] = useState(initialData || null);
  const [tab, setTab] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);

  const [openEdit, setOpenEdit] = useState(false);
  const [statusAnchor, setStatusAnchor] = useState(null);
  const [profitDetailAnchor, setProfitDetailAnchor] = useState(null);
  const [openBudget, setOpenBudget] = useState(false);
  const [nextBudgetNo, setNextBudgetNo] = useState('');
  const [openEditBudget, setOpenEditBudget] = useState(false);
  const [openDeliver, setOpenDeliver] = useState(false);
  const [openPayment, setOpenPayment] = useState(false);
  const [openTimeTracking, setOpenTimeTracking] = useState(false);
  const [csvUploadOpen, setCsvUploadOpen] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const [dateDeliver, setDateDeliver] = useState(null);
  const [datePayment, setDatePayment] = useState(null);
  const [expenseDialogId, setExpenseDialogId] = useState(null);
  const [timeTrackingEnabled, setTimeTrackingEnabled] = useState(false);
  const [timeTrackingLinkEnabled, setTimeTrackingLinkEnabled] = useState(true);
  const [statusDraft, setStatusDraft] = useState({});
  const [statusSaving, setStatusSaving] = useState(false);
  const [expensesList, setExpensesList] = useState([]);
  const [expensesLoading, setExpensesLoading] = useState(false);

  const { control, handleSubmit, reset, setValue } = useForm();

  useEffect(() => {
    if (!openBudget) return;
    api
      .get(`${process.env.REACT_APP_API_URL}/budget/next-number`)
      .then(({ data }) => setNextBudgetNo(data?.budget_number || ''))
      .catch(() => setNextBudgetNo(''));
  }, [openBudget]);

  useEffect(() => {
    if (!id) return;
    dispatch(actions.getInformation());
    dispatch(actions.budgetAll({ project_id: id }));
    dispatch(actions.timestampAll({ project_id: id }));
    dispatch(actions.meGet());
    // ดึง project ใหม่ในพื้นหลัง — ถ้ามี initialData แสดงข้อมูลเดิมก่อนได้เลย
    dispatch(actions.projectGet(id));
  }, [id, openBudget, openEditBudget]);

  useEffect(() => {
    if (project?.name && project?.id === id) {
      setCachedProject(project);
    }
  }, [project]);

  useEffect(() => {
    setTimeTrackingEnabled(project?.time_tracking_enabled || false);
    setTimeTrackingLinkEnabled(project?.time_tracking_link_enabled !== false);
  }, [project]);

  useEffect(() => {
    const src = cachedProject;
    if (!src) return;
    setStatusDraft({
      work_status: src.work_status || '',
      finance_status: src.finance_status || '',
      bg_usage_category: src.bg_usage_category || '',
      legal_warranty: src.legal_warranty || false,
      legal_debt: src.legal_debt || false,
      legal_lawsuit: src.legal_lawsuit || false,
    });
  }, [cachedProject?.updatedAt, cachedProject?._id || cachedProject?.id]);

  useEffect(() => {
    if (tab !== 2 || !id) return;
    setExpensesLoading(true);
    api
      .get(
        `${process.env.REACT_APP_API_URL}/expenses?findProject=${id}&size=2000`,
      )
      .then((res) => {
        const rows = res.data?.rows || res.data || [];
        setExpensesList(
          [...rows].sort((a, b) => new Date(b.date) - new Date(a.date)),
        );
      })
      .catch(console.error)
      .finally(() => setExpensesLoading(false));
  }, [tab, id]);

  const handleSaveStatus = async () => {
    setStatusSaving(true);
    try {
      await dispatch(actions.projectPatchDashboard(id, statusDraft));
      dispatch(actions.projectUpdateLocal(id, statusDraft));
      onSaved?.();
      onClose?.();
    } catch (err) {
      console.error('Status save failed', err);
    } finally {
      setStatusSaving(false);
    }
  };

  const handleStatusDraftChange = (field, value) => {
    const patch = { [field]: value };
    if (
      field === 'finance_status' &&
      (value === 'completed_po' || value === 'last_installment')
    )
      patch.work_status = 'done';
    if (
      field === 'work_status' &&
      (value === 'waiting' || value === 'in_progress')
    ) {
      patch.legal_warranty = false;
    }
    if (field === 'legal_warranty' && value === true)
      patch.work_status = 'done';
    if (
      field === 'bg_usage_category' &&
      value === 'no_bg_usage' &&
      statusDraft.work_status !== 'done'
    )
      return;
    setStatusDraft((prev) => ({ ...prev, ...patch }));
  };

  const onSubmitBudget = async (data) => {
    if (!window.confirm('บันทึก')) return;
    try {
      await dispatch(actions.budgetCreate({ ...data, project_id: id }));
      dispatch(actions.projectGet(id));
      onSaved?.();
      reset();
      setOpenBudget(false);
    } catch {
      alert('มีรหัสงบประมาณนี้ในระบบแล้ว');
    }
  };

  const onSubmitEditBudget = async (data) => {
    if (!window.confirm('บันทึก')) return;
    try {
      await dispatch(actions.budgetPut(data.id, { ...data, project_id: id }));
      dispatch(actions.projectGet(id));
      onSaved?.();
      reset();
      setOpenEditBudget(false);
    } catch {
      alert('มีรหัสงบประมาณนี้ในระบบแล้ว');
    }
  };

  const handleEditBudget = (data) => {
    setOpenEditBudget(true);
    setValue('budget_number', data?.budget_number);
    setValue('name', data?.name);
    setValue('cost', data?.cost);
    setValue('id', data?.id);
  };

  const handleDeleteBudget = async (item) => {
    if (!_.isEmpty(item?.expenses))
      return alert('ไม่สามารถลบงบประมาณที่มีรายการค่าใช้จ่ายผูกอยู่ได้');
    if (window.confirm('ลบงบประมาณนี้?')) {
      await dispatch(actions.budgetDelete(item?.id));
      dispatch(actions.projectGet(id));
      dispatch(actions.budgetAll({ project_id: id }));
      onSaved?.();
    }
  };

  const handleDeleteExpense = async (expenseId) => {
    if (window.confirm('ลบข้อมูล')) {
      await dispatch(actions.expensesDelete(expenseId));
      dispatch(actions.expensesAll({}));
    }
  };

  const handleEditExpense = (expenseId) => setExpenseDialogId(expenseId);

  const handleApprove = async (expenseId) => {
    await dispatch(
      actions.expensesPut(expenseId, {
        status: 'APPROVE',
        approval_actor: me?.userData?.id,
        approval_actor_name: `${me?.userData?.firstname || ''} ${
          me?.userData?.lastname || ''
        }`.trim(),
      }),
    );
    dispatch(actions.expensesAll({}));
  };

  const handleSuccess = async (expenseId) => {
    await dispatch(actions.expensesPut(expenseId, { status: 'SUCCESS' }));
    dispatch(actions.expensesAll({}));
  };

  const handleDeliver = async () => {
    if (!dateDeliver) return alert('เลือกวันที่ส่งมอบงาน');
    if (window.confirm('ยืนยันข้อมูล')) {
      await dispatch(
        actions.projectPut(id, {
          deliver_status: { status: true, date: dateDeliver },
          operation_status: 'DELIVERY',
        }),
      );
      dispatch(actions.projectGet(id));
      onSaved?.();
      setOpenDeliver(false);
    }
  };

  const handleAddFromFile = async () => {
    if (_.isEmpty(csvData)) return alert('ไม่สามารถอ่านไฟล์รายการได้');
    try {
      await dispatch(actions.budgetCreate({ arr: csvData, project_id: id }));
      alert('สำเร็จ');
      setCsvUploadOpen(false);
      setCsvData([]);
      dispatch(actions.budgetAll({ project_id: id }));
      onSaved?.();
    } catch {
      alert('เพิ่มไม่สำเร็จ');
    }
  };

  const handleToggleTimeTracking = async (checked) => {
    if (!window.confirm(checked ? 'เปิดการลงเวลา?' : 'ปิดการลงเวลา?')) return;
    await dispatch(actions.projectPut(id, { time_tracking_enabled: checked }));
    setTimeTrackingEnabled(checked);
    dispatch(actions.projectGet(id));
  };

  const handleToggleTimeTrackingLink = async (checked) => {
    if (!window.confirm(checked ? 'เปิดลิงก์ Manpower?' : 'ปิดลิงก์ Manpower?'))
      return;
    await dispatch(
      actions.projectPut(id, { time_tracking_link_enabled: checked }),
    );
    setTimeTrackingLinkEnabled(checked);
    dispatch(actions.projectGet(id));
  };

  const handleChangeStatus = async (newStatus) => {
    setStatusAnchor(null);
    await dispatch(actions.projectPut(id, { operation_status: newStatus }));
    dispatch(actions.projectGet(id));
    onSaved?.();
  };

  const p = cachedProject || project;
  const link = `${info?.url}/manpower/timestamp/${id}`;
  const status = STATUS_MAP[p?.operation_status] || {
    label: 'ไม่ระบุ',
    color: 'default',
  };

  // คำนวณ total_expenses จาก Grand Total ของแต่ละ budget รวมกัน (Paid + Expected + AP Pending - รอเงินคืน) — เกณฑ์เดียวกับคอลัมน์ Grand Total ใน BudgetTable.js
  // เก็บ remaining ต่อ budget ไว้ในก้อนเดียวกันด้วย ใช้ทำเลข "กำไรคาดการณ์ (ซ่อน)" ด้านล่าง ไม่ต้องวนซ้ำสอบรอบ
  // ใช้ budget?.rows โหลดมาหรือยังเป็นตัวเช็ค ไม่ใช่จำนวน expenses จริง เพราะ budget ที่มีแต่ AP Pending (ยังไม่มี expenses เลย) ก็ต้องคำนวณสดเช่นกัน ไม่งั้นจะ fallback ไปใช้ p?.total_expenses ที่ไม่รวม AP Pending
  const hasBudgetData = (budget?.rows?.length || 0) > 0;
  const budgetAgg = (budget?.rows || []).map((b) => {
    const paid = _.sumBy(b?.expenses, (exp) =>
      exp?.status === 'SUCCESS' ? exp?.price || 0 : 0,
    );
    const expected = _.sumBy(b?.expenses, (exp) =>
      exp?.status !== 'SUCCESS' && exp?.status !== 'REJECT'
        ? exp?.price || 0
        : 0,
    );
    const apPending = _.sumBy(
      _.filter(b?.pending_items, (i) => !i?.paid),
      (i) => i?.amount || 0,
    );
    const refundPending = _.sumBy(
      _.filter(b?.refund_items, (i) => !i?.refunded),
      (i) => i?.amount || 0,
    );
    const grandTotal = paid + expected + apPending - refundPending;
    return { grandTotal, remaining: (b?.cost || 0) - grandTotal };
  });
  const totalExpensesLocal = _.sumBy(budgetAgg, 'grandTotal');
  const totalExpenses = hasBudgetData
    ? totalExpensesLocal
    : p?.total_expenses || 0;
  // รวม Remaining เฉพาะ budget ที่เหลือเป็นบวก (ก้อนที่ใช้เกินไม่เอามาหักลบ) — ใช้ทำเลข "กำไรคาดการณ์ (ซ่อน)"
  // เท่านั้น ไม่โชว์ตรงๆ บนหน้าจอ เพราะถ้าแคปหน้าจอส่งหน้างาน ไม่อยากให้เห็นว่ายังมีงบเหลือ เดี๋ยวเข้าใจผิดว่าเบิกเพิ่มได้
  const positiveRemainingSum = hasBudgetData
    ? _.sumBy(budgetAgg, (t) => (t.remaining > 0 ? t.remaining : 0))
    : 0;
  // ตัวเลขหลักของ hiddenProfit ใน popup: เสมอ มูลค่างาน - จ่ายแล้ว + งบเหลือ(บวก)
  const hiddenProfit = (p?.cost || 0) - totalExpenses + positiveRemainingSum;
  // % ของ กำไรคาดการณ์: เปลี่ยนแปลงตามสถานะ ไม่ใช้ BG แล้ว
  const estimatedProfitForPercent = (p?.cost || 0) - totalExpenses + (statusDraft.bg_usage_category === 'no_bg_usage' ? positiveRemainingSum : 0);

  const expPct = Math.min(
    (totalExpenses / (p?.total_budget || 1)) * 100 || 0,
    100,
  );

  if (!cachedProject && (project?.isLoading || !project?.isCompleted)) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 300,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2.5, overflowX: 'hidden' }}>
      {/* ── Header ── */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        sx={{ mb: 2 }}
      >
        <Box>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ mb: 0.5 }}
          >
            <Typography variant="subtitle2" fontWeight={700} color="primary">
              {p?.project_number}
            </Typography>
            <Chip
              size="small"
              label={status.label}
              color={status.color}
              sx={{ height: 20, fontSize: '0.7rem', cursor: 'pointer' }}
              onClick={(e) => setStatusAnchor(e.currentTarget)}
            />
            {p?.deliver_status?.status && (
              <Chip
                size="small"
                label="ส่งมอบแล้ว"
                color="success"
                variant="outlined"
                sx={{ height: 20, fontSize: '0.7rem' }}
              />
            )}
          </Stack>
          <Typography variant="body1" fontWeight={600}>
            {p?.name}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {p?.customer}
          </Typography>
        </Box>
        {(() => {
          const remainBudget = (p?.total_budget || 0) - totalExpenses;
          const targetProfit = (p?.cost || 0) - (p?.total_budget || 0);
          const estimatedProfit = (p?.cost || 0) - totalExpenses;
          const cost = p?.cost || 0;
          const rows = [
            {
              leftLabel: 'มูลค่างาน',
              leftVal: cost,
              leftColor: '#1976d2',
              leftPct: null,
              rightLabel: 'จ่ายแล้ว',
              rightVal: totalExpenses,
              rightColor: '#d32f2f',
              rightPct: fmtPct(totalExpenses, cost),
            },
            {
              leftLabel: 'งบประมาณ',
              leftVal: p?.total_budget,
              leftColor: '#ed6c02',
              leftPct: fmtPct(p?.total_budget, cost),
              rightLabel: 'เหลืองบประมาณ',
              rightVal: remainBudget,
              rightColor: remainBudget >= 0 ? '#2e7d32' : '#d32f2f',
              rightPct: fmtPct(remainBudget, cost),
            },
            {
              leftLabel: 'กำไรตั้งเป้า',
              leftVal: targetProfit,
              leftColor: '#1976d2',
              leftPct: fmtPct(targetProfit, cost),
              rightLabel: 'กำไรคาดการณ์',
              rightVal: estimatedProfitForPercent,
              rightColor: estimatedProfitForPercent >= 0 ? '#2e7d32' : '#d32f2f',
              rightPct: fmtPct(estimatedProfitForPercent, cost),
            },
          ];
          return (
            <Stack direction="row" alignItems="flex-end" spacing={0.5}>
              <Box
                sx={{
                  flex: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 2,
                  overflow: 'hidden',
                }}
              >
                {rows.map(
                  (
                    {
                      leftLabel,
                      leftVal,
                      leftColor,
                      leftPct,
                      rightLabel,
                      rightVal,
                      rightColor,
                      rightPct,
                    },
                    i,
                  ) => (
                    <Stack
                      key={i}
                      direction="row"
                      divider={
                        <Box sx={{ width: '1px', bgcolor: 'divider' }} />
                      }
                      sx={{
                        borderBottom:
                          i < rows.length - 1 ? '1px solid' : 'none',
                        borderColor: 'divider',
                      }}
                    >
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ flex: 1, px: 2, py: 0.75 }}
                      >
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ mr: 2 }}
                        >
                          {leftLabel}
                        </Typography>
                        <Box sx={{ textAlign: 'right' }}>
                          <Typography
                            variant="body2"
                            fontWeight={700}
                            sx={{ color: leftColor }}
                          >
                            {fmt(leftVal)}
                          </Typography>
                          {leftPct && (
                            <Typography
                              variant="caption"
                              sx={{ color: leftColor, opacity: 0.75 }}
                            >
                              {leftPct}
                            </Typography>
                          )}
                        </Box>
                      </Stack>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ flex: 1, px: 2, py: 0.75 }}
                      >
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ mr: 2 }}
                        >
                          {rightLabel}
                        </Typography>
                        <Box sx={{ textAlign: 'right' }}>
                          <Typography
                            variant="body2"
                            fontWeight={700}
                            sx={{ color: rightColor }}
                          >
                            {fmt(rightVal)}
                          </Typography>
                          {rightPct && (
                            <Typography
                              variant="caption"
                              sx={{ color: rightColor, opacity: 0.75 }}
                            >
                              {rightPct}
                            </Typography>
                          )}
                        </Box>
                      </Stack>
                    </Stack>
                  ),
                )}
              </Box>
              <Tooltip title="ดูกำไรคาดการณ์รวมงบเหลือ (ไม่โชว์บนหน้าจอปกติ)">
                <IconButton
                  size="small"
                  sx={{ mb: 0.5 }}
                  onClick={(e) => setProfitDetailAnchor(e.currentTarget)}
                >
                  <VisibilityIcon
                    sx={{ fontSize: 16, color: 'text.disabled' }}
                  />
                </IconButton>
              </Tooltip>
            </Stack>
          );
        })()}
        <Popover
          open={Boolean(profitDetailAnchor)}
          anchorEl={profitDetailAnchor}
          onClose={() => setProfitDetailAnchor(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Box sx={{ p: 1.5, minWidth: 280 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
              sx={{ mb: 0.5 }}
            >
              กำไรคาดการณ์ (รวมงบเหลือทุกก้อน)
            </Typography>
            <Typography
              variant="body1"
              fontWeight={700}
              sx={{ color: hiddenProfit >= 0 ? '#2e7d32' : '#d32f2f', mb: 0.3 }}
            >
              {fmt(hiddenProfit)}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: hiddenProfit >= 0 ? '#2e7d32' : '#d32f2f',
                opacity: 0.75,
                display: 'block',
                mb: 1,
              }}
            >
              {fmtPct(hiddenProfit, p?.cost || 0)}
            </Typography>
            <Divider sx={{ my: 0.75 }} />
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
              sx={{ fontSize: '0.65rem', lineHeight: 1.6, mt: 0.75 }}
            >
              <strong>สูตร:</strong>
              <div style={{ marginTop: '4px' }}>
                {fmt(p?.cost || 0)} − {fmt(totalExpenses)} + {fmt(positiveRemainingSum)}
              </div>
            </Typography>
          </Box>
        </Popover>
        <Stack direction="column" spacing={1} alignItems="flex-end">
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Tooltip title="แก้ไขโครงการ">
              <IconButton size="small" onClick={() => setOpenEdit(true)}>
                <ModeEditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="เปิดหน้าเต็ม">
              <IconButton
                size="small"
                onClick={() => history.push(`/project/project/detail/${id}`)}
              >
                <OpenInNewIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            {onClose && (
              <Tooltip title="ปิด">
                <IconButton size="small" onClick={onClose} sx={{ ml: 0.5 }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
          <Stack direction="column" spacing={0.5} alignItems="stretch">
            <Button
              size="small"
              variant="outlined"
              onClick={() => setOpenDeliver(true)}
            >
              ส่งมอบงาน
            </Button>
            <Button
              size="small"
              variant="outlined"
              startIcon={<AccessTimeIcon fontSize="small" />}
              onClick={() => setOpenTimeTracking(true)}
            >
              ลงเวลา {timeTrackingEnabled ? '(เปิด)' : '(ปิด)'}
            </Button>
          </Stack>
        </Stack>
      </Stack>

      {/* Status Menu */}
      <Menu
        anchorEl={statusAnchor}
        open={Boolean(statusAnchor)}
        onClose={() => setStatusAnchor(null)}
      >
        {Object.entries(STATUS_MAP).map(([key, { label, color }]) => (
          <MenuItem key={key} onClick={() => handleChangeStatus(key)} dense>
            <ListItemIcon sx={{ minWidth: 28 }}>
              {p?.operation_status === key && (
                <CheckIcon fontSize="small" color="primary" />
              )}
            </ListItemIcon>
            <ListItemText>
              <Chip
                size="small"
                label={label}
                color={color}
                sx={{ fontSize: '0.72rem', height: 20 }}
              />
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>

      {/* Edit Popup */}
      <ProjectEditPopup
        propId={id}
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        onSaved={() => {
          dispatch(actions.projectGet(id));
          onSaved?.();
        }}
      />

      <DevWinBadge
        num={113}
        name="Project · Expense Detail"
        open={!!expenseDialogId}
      />
      <Dialog
        open={!!expenseDialogId}
        onClose={() => setExpenseDialogId(null)}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: { maxHeight: '92vh' } }}
      >
        <DialogContent sx={{ p: 2 }}>
          {expenseDialogId && (
            <ExpensesDetail
              propId={expenseDialogId}
              onClose={() => {
                setExpenseDialogId(null);
                dispatch(actions.budgetAll({ project_id: id }));
              }}
            />
          )}
        </DialogContent>
      </Dialog>

      {/* ── Progress ── */}
      <Box sx={{ mb: 2 }}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="caption" color="text.secondary">
            การใช้งบประมาณ
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {expPct.toFixed(1)}%
          </Typography>
        </Stack>
        <LinearProgress
          variant="determinate"
          value={expPct}
          sx={{
            height: 6,
            borderRadius: 3,
            bgcolor: '#ffe0b2',
            '& .MuiLinearProgress-bar': {
              bgcolor: expPct > 100 ? '#d32f2f' : '#fb923c',
            },
          }}
        />
      </Box>

      <Divider sx={{ mb: 1 }} />

      {/* ── Tabs ── */}
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{
          minHeight: 36,
          '& .MuiTab-root': { minHeight: 36, fontSize: '0.8rem', py: 0.5 },
        }}
      >
        <Tab label="แดชบอร์ด" />
        <Tab label="งบประมาณ" />
        <Tab label="รายการเบิก" />
        <Tab label="ลงเวลา" />
        <Tab label="สถานภาพ" />
        <Tab label="เอกสาร" />
      </Tabs>

      <Box sx={{ pt: 1.5 }}>
        {/* แดชบอร์ด */}
        {tab === 0 && (
          <BudgetTable
            budget={budget?.rows}
            handleEditBudget={handleEditBudget}
            handleDeleteBudget={handleDeleteBudget}
            onEditExpense={handleEditExpense}
          />
        )}

        {/* งบประมาณ */}
        {tab === 1 && (
          <Box>
            <Stack
              direction="row"
              spacing={1}
              justifyContent="flex-end"
              sx={{ mb: 1 }}
            >
              <Button
                size="small"
                variant="contained"
                onClick={() => setOpenBudget(true)}
              >
                เพิ่มงบประมาณ
              </Button>
              <Button
                size="small"
                variant="outlined"
                color="success"
                startIcon={<UploadFileIcon />}
                onClick={() => setCsvUploadOpen(true)}
              >
                นำเข้าข้อมูล
              </Button>
            </Stack>
            <BudgetListTable
              budget={budget?.rows}
              handleEditBudget={handleEditBudget}
              handleDeleteBudget={handleDeleteBudget}
            />
          </Box>
        )}

        {/* รายการเบิก */}
        {tab === 2 && (
          <Box>
            {expensesLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress size={28} />
              </Box>
            ) : expensesList.length === 0 ? (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ py: 3, textAlign: 'center' }}
              >
                ยังไม่มีรายการเบิก
              </Typography>
            ) : (
              <TableContainer sx={{ maxHeight: 420 }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      {[
                        'วันที่',
                        'รหัส',
                        'รายการ',
                        'หมวด',
                        'ผู้เบิก',
                        'ผู้รับเงิน',
                        'จำนวน',
                        'สถานะ',
                      ].map((h) => (
                        <TableCell
                          key={h}
                          sx={{
                            bgcolor: '#3730a3',
                            color: '#fff',
                            fontWeight: 700,
                            fontSize: '0.72rem',
                            whiteSpace: 'nowrap',
                            py: 0.75,
                          }}
                        >
                          {h}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {expensesList.map((exp, i) => {
                      const st =
                        EXP_STATUS_MAP[exp.status] || EXP_STATUS_MAP.PENDING;
                      const empName = exp.employee
                        ? `${exp.employee.firstname || ''} ${
                            exp.employee.lastname || ''
                          }`.trim()
                        : '-';
                      return (
                        <TableRow
                          key={exp._id || i}
                          onClick={() => setExpenseDialogId(exp._id)}
                          sx={{
                            bgcolor: i % 2 === 0 ? '#fff' : '#f8f8fc',
                            cursor: 'pointer',
                            '&:hover': { bgcolor: '#eff6ff' },
                          }}
                        >
                          <TableCell
                            sx={{ fontSize: '0.72rem', whiteSpace: 'nowrap' }}
                          >
                            {exp.date
                              ? dayjs(exp.date).format('DD/MM/BB')
                              : '-'}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: '0.72rem',
                              whiteSpace: 'nowrap',
                              color: '#64748b',
                            }}
                          >
                            {exp.code || '-'}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: '0.72rem',
                              maxWidth: 180,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            <Tooltip
                              title={exp.name || ''}
                              placement="top-start"
                              disableHoverListener={!exp.name}
                            >
                              <span>{exp.name || '-'}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: '0.72rem',
                              whiteSpace: 'nowrap',
                              color: '#64748b',
                            }}
                          >
                            {exp.budget?.name || '-'}
                          </TableCell>
                          <TableCell
                            sx={{ fontSize: '0.72rem', whiteSpace: 'nowrap' }}
                          >
                            {empName}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: '0.72rem',
                              whiteSpace: 'nowrap',
                              color: '#64748b',
                            }}
                          >
                            {exp.payee?.name || '-'}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: '0.72rem',
                              whiteSpace: 'nowrap',
                              textAlign: 'right',
                              fontWeight: 600,
                            }}
                          >
                            {Number(exp.price || 0).toLocaleString('th-TH', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </TableCell>
                          <TableCell sx={{ py: 0.4 }}>
                            <Chip
                              label={st.label}
                              size="small"
                              sx={{
                                bgcolor: st.bg,
                                color: st.color,
                                fontWeight: 700,
                                fontSize: '0.65rem',
                                height: 18,
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>
        )}

        {/* ลงเวลา */}
        {tab === 3 && <CheckInlist timestamp={timestamp} />}

        {/* สถานภาพ */}
        {tab === 4 && (
          <Box>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: 1.5,
                mb: 1.5,
              }}
            >
              {/* งาน */}
              <Box
                sx={{
                  p: 1.25,
                  borderRadius: 1.5,
                  border: '1px solid',
                  borderColor: '#2563eb28',
                  boxShadow: 'inset 3px 0 0 #2563eb',
                  bgcolor: '#fafbff',
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    display: 'block',
                    fontWeight: 700,
                    fontSize: '0.67rem',
                    color: '#2563eb',
                    mb: 0.6,
                    pb: 0.3,
                    borderBottom: '1px solid #2563eb25',
                  }}
                >
                  ด้านงาน
                </Typography>
                <Stack spacing={0.3}>
                  {WORK_OPTIONS.map((opt) => {
                    const selected = statusDraft.work_status === opt.key;
                    return (
                      <Box
                        key={opt.key}
                        onClick={() =>
                          handleStatusDraftChange(
                            'work_status',
                            selected ? '' : opt.key,
                          )
                        }
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.6,
                          py: 0.35,
                          px: 0.5,
                          cursor: 'pointer',
                          borderRadius: 1,
                          bgcolor: selected ? `${opt.color}18` : 'transparent',
                          border: '1px solid',
                          borderColor: selected
                            ? `${opt.color}60`
                            : 'transparent',
                          '&:hover': { bgcolor: `${opt.color}10` },
                          transition: 'all 0.1s',
                        }}
                      >
                        <Box
                          sx={{
                            width: 13,
                            height: 13,
                            borderRadius: '50%',
                            flexShrink: 0,
                            border: '2px solid',
                            borderColor: selected ? opt.color : '#cbd5e1',
                            bgcolor: selected ? opt.color : 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {selected && (
                            <Box
                              sx={{
                                width: 4,
                                height: 4,
                                borderRadius: '50%',
                                bgcolor: '#fff',
                              }}
                            />
                          )}
                        </Box>
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: '0.72rem',
                            color: selected ? opt.color : 'text.primary',
                            fontWeight: selected ? 700 : 400,
                            lineHeight: 1.4,
                          }}
                        >
                          {opt.label}
                        </Typography>
                      </Box>
                    );
                  })}
                </Stack>
              </Box>

              {/* การเงิน */}
              <Box
                sx={{
                  p: 1.25,
                  borderRadius: 1.5,
                  border: '1px solid',
                  borderColor: '#d9770628',
                  boxShadow: 'inset 3px 0 0 #d97706',
                  bgcolor: '#fafbff',
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    display: 'block',
                    fontWeight: 700,
                    fontSize: '0.67rem',
                    color: '#d97706',
                    mb: 0.6,
                    pb: 0.3,
                    borderBottom: '1px solid #d9770625',
                  }}
                >
                  ด้านการเงิน
                </Typography>
                <Stack spacing={0.3}>
                  {FINANCE_OPTIONS.map((opt) => {
                    const selected = statusDraft.finance_status === opt.key;
                    return (
                      <Box
                        key={opt.key}
                        onClick={() =>
                          handleStatusDraftChange(
                            'finance_status',
                            selected ? '' : opt.key,
                          )
                        }
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.6,
                          py: 0.35,
                          px: 0.5,
                          cursor: 'pointer',
                          borderRadius: 1,
                          bgcolor: selected ? `${opt.color}18` : 'transparent',
                          border: '1px solid',
                          borderColor: selected
                            ? `${opt.color}60`
                            : 'transparent',
                          '&:hover': { bgcolor: `${opt.color}10` },
                          transition: 'all 0.1s',
                        }}
                      >
                        <Box
                          sx={{
                            width: 13,
                            height: 13,
                            borderRadius: '50%',
                            flexShrink: 0,
                            border: '2px solid',
                            borderColor: selected ? opt.color : '#cbd5e1',
                            bgcolor: selected ? opt.color : 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {selected && (
                            <Box
                              sx={{
                                width: 4,
                                height: 4,
                                borderRadius: '50%',
                                bgcolor: '#fff',
                              }}
                            />
                          )}
                        </Box>
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: '0.72rem',
                            color: selected ? opt.color : 'text.primary',
                            fontWeight: selected ? 700 : 400,
                            lineHeight: 1.4,
                          }}
                        >
                          {opt.label}
                        </Typography>
                      </Box>
                    );
                  })}
                </Stack>
              </Box>
            </Box>

            <Box
              sx={{
                p: 1.25,
                borderRadius: 1.5,
                border: '1px solid',
                borderColor: '#37415128',
                boxShadow: 'inset 3px 0 0 #374151',
                bgcolor: '#f5f6f7',
                mb: 1.5,
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  display: 'block',
                  fontWeight: 700,
                  fontSize: '0.67rem',
                  color: '#374151',
                  mb: 0.6,
                  pb: 0.3,
                  borderBottom: '1px solid #37415125',
                }}
              >
                หมวดการใช้ BUDGET
              </Typography>
              <Stack spacing={0.3}>
                {BG_USAGE_OPTIONS.map((opt) => {
                  const selected = statusDraft.bg_usage_category === opt.key;
                  const bgUsageDisabled = statusDraft.work_status !== 'done';
                  return (
                    <Tooltip
                      key={opt.key}
                      title={
                        bgUsageDisabled ? 'งานยังไม่เสร็จ 100% เลือกไม่ได้' : ''
                      }
                      placement="top"
                    >
                      <Box
                        onClick={() =>
                          !bgUsageDisabled &&
                          handleStatusDraftChange(
                            'bg_usage_category',
                            selected ? '' : opt.key,
                          )
                        }
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.6,
                          py: 0.35,
                          px: 0.5,
                          cursor: bgUsageDisabled ? 'not-allowed' : 'pointer',
                          borderRadius: 1,
                          bgcolor: selected ? `${opt.color}18` : 'transparent',
                          border: '1px solid',
                          borderColor: selected
                            ? `${opt.color}60`
                            : 'transparent',
                          opacity: bgUsageDisabled ? 0.5 : 1,
                          '&:hover': bgUsageDisabled
                            ? {}
                            : { bgcolor: `${opt.color}10` },
                          transition: 'all 0.1s',
                        }}
                      >
                        <Box
                          sx={{
                            width: 13,
                            height: 13,
                            borderRadius: '50%',
                            flexShrink: 0,
                            border: '2px solid',
                            borderColor: selected ? opt.color : '#cbd5e1',
                            bgcolor: selected ? opt.color : 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {selected && (
                            <Box
                              sx={{
                                width: 4,
                                height: 4,
                                borderRadius: '50%',
                                bgcolor: '#fff',
                              }}
                            />
                          )}
                        </Box>
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: '0.72rem',
                            color: selected ? opt.color : 'text.primary',
                            fontWeight: selected ? 700 : 400,
                            lineHeight: 1.4,
                          }}
                        >
                          {opt.label}
                        </Typography>
                      </Box>
                    </Tooltip>
                  );
                })}
              </Stack>
            </Box>

            {/* กฎหมาย/ความเสี่ยง */}
            <Box
              sx={{
                p: 1.25,
                borderRadius: 1.5,
                border: '1px solid',
                borderColor: '#7c3aed28',
                boxShadow: 'inset 3px 0 0 #7c3aed',
                bgcolor: '#fafbff',
                mb: 1.5,
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  display: 'block',
                  fontWeight: 700,
                  fontSize: '0.67rem',
                  color: '#7c3aed',
                  mb: 0.6,
                  pb: 0.3,
                  borderBottom: '1px solid #7c3aed25',
                }}
              >
                กฎหมาย / ความเสี่ยง
              </Typography>
              <Stack direction="row" spacing={1}>
                {LEGAL_OPTIONS.map((opt) => {
                  const checked = Boolean(statusDraft[opt.key]);
                  const disabled =
                    opt.key === 'legal_warranty' &&
                    statusDraft.work_status !== 'done';
                  return (
                    <Tooltip
                      key={opt.key}
                      title={disabled ? 'ต้องงานเสร็จ 100% ก่อน' : ''}
                      placement="top"
                    >
                      <Box
                        onClick={() =>
                          !disabled &&
                          handleStatusDraftChange(opt.key, !checked)
                        }
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          py: 0.4,
                          px: 0.75,
                          cursor: disabled ? 'not-allowed' : 'pointer',
                          borderRadius: 1,
                          bgcolor: checked ? `${opt.color}15` : 'transparent',
                          border: '1px solid',
                          borderColor: checked
                            ? `${opt.color}60`
                            : 'transparent',
                          opacity: disabled ? 0.45 : 1,
                          '&:hover': disabled
                            ? {}
                            : { bgcolor: `${opt.color}10` },
                          transition: 'all 0.1s',
                        }}
                      >
                        <Box
                          sx={{
                            width: 13,
                            height: 13,
                            borderRadius: 0.5,
                            flexShrink: 0,
                            border: '2px solid',
                            borderColor: checked ? opt.color : '#cbd5e1',
                            bgcolor: checked ? opt.color : 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {checked && (
                            <Box
                              sx={{
                                width: 7,
                                height: 4,
                                borderLeft: '2px solid #fff',
                                borderBottom: '2px solid #fff',
                                transform:
                                  'rotate(-45deg) translate(1px, -1px)',
                              }}
                            />
                          )}
                        </Box>
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: '0.72rem',
                            color: checked ? opt.color : 'text.primary',
                            fontWeight: checked ? 700 : 400,
                          }}
                        >
                          {opt.label}
                        </Typography>
                      </Box>
                    </Tooltip>
                  );
                })}
              </Stack>
            </Box>

            {/* ภาระผูกพัน auto */}
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ mb: 2 }}
            >
              <Typography variant="caption" color="text.secondary">
                ภาระผูกพัน:
              </Typography>
              {computeHasCommitment(statusDraft) ? (
                <Chip
                  size="small"
                  label="มีภาระผูกพัน"
                  sx={{
                    bgcolor: '#fef3c7',
                    color: '#92400e',
                    fontWeight: 700,
                    fontSize: '0.72rem',
                  }}
                />
              ) : (
                <Chip
                  size="small"
                  label="ไม่มีภาระผูกพัน"
                  sx={{
                    bgcolor: '#dcfce7',
                    color: '#166534',
                    fontWeight: 700,
                    fontSize: '0.72rem',
                  }}
                />
              )}
            </Stack>

            <Stack direction="row" justifyContent="flex-end">
              <Button
                variant="contained"
                size="small"
                startIcon={
                  statusSaving ? (
                    <CircularProgress size={14} color="inherit" />
                  ) : (
                    <SaveIcon />
                  )
                }
                onClick={handleSaveStatus}
                disabled={statusSaving}
              >
                บันทึก
              </Button>
            </Stack>
          </Box>
        )}

        {/* เอกสาร */}
        {tab === 5 && (
          <Box>
            {p?.documents?.length > 0 ? (
              <Stack spacing={0.5}>
                {p.documents.map((doc, i) => (
                  <Box
                    key={i}
                    onClick={() => window.open(doc.url, '_blank')}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1.5,
                      p: 1.5,
                      borderRadius: 1.5,
                      border: '1px solid',
                      borderColor: 'divider',
                      cursor: 'pointer',
                      '&:hover': { bgcolor: 'action.hover' },
                    }}
                  >
                    <OpenInNewIcon
                      fontSize="small"
                      color="primary"
                      sx={{ flexShrink: 0 }}
                    />
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="body2" fontWeight={600}>
                        {doc.title || `เอกสาร ${i + 1}`}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                          display: 'block',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {doc.url}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Stack>
            ) : (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ py: 3, textAlign: 'center' }}
              >
                ยังไม่มีเอกสาร — กดปุ่มแก้ไข (✏️) เพื่อเพิ่มลิงค์
              </Typography>
            )}
          </Box>
        )}
      </Box>

      {/* ── Modals ── */}
      <DevWinBadge num={114} name="Project · Add Budget" open={openBudget} />
      <Modal open={openBudget} onClose={() => setOpenBudget(false)}>
        <Box sx={modalStyle}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 2,
            }}
          >
            <Typography variant="subtitle1" fontWeight={600}>
              เพิ่มงบประมาณ
            </Typography>
            {nextBudgetNo && (
              <Tooltip
                title="เลขนี้เป็นค่าประมาณ อาจเปลี่ยนได้ถ้ามีการสร้างงบฯ พร้อมกัน"
                arrow
              >
                <Chip
                  label={nextBudgetNo}
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{ fontWeight: 700, fontFamily: 'monospace' }}
                />
              </Tooltip>
            )}
          </Box>
          <form onSubmit={handleSubmit(onSubmitBudget)}>
            <BudgetForm Controller={Controller} control={control} />
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <Button variant="contained" type="submit" size="small">
                บันทึก
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>

      <DevWinBadge
        num={115}
        name="Project · Edit Budget"
        open={openEditBudget}
      />
      <Modal open={openEditBudget} onClose={() => setOpenEditBudget(false)}>
        <Box sx={modalStyle}>
          <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
            แก้ไขงบประมาณ
          </Typography>
          <form onSubmit={handleSubmit(onSubmitEditBudget)}>
            <BudgetForm Controller={Controller} control={control} showNumber />
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <Button variant="contained" type="submit" size="small">
                บันทึก
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>

      <DevWinBadge num={116} name="Project · Deliver" open={openDeliver} />
      <Modal open={openDeliver} onClose={() => setOpenDeliver(false)}>
        <Box sx={modalStyle}>
          <form onSubmit={handleSubmit(handleDeliver)}>
            <DeliverForm
              dateDeliver={dateDeliver}
              setDateDeliver={setDateDeliver}
              title="ส่งมอบงาน"
            />
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <Button variant="contained" type="submit" size="small">
                บันทึก
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>

      <DevWinBadge
        num={117}
        name="Project · Time Tracking"
        open={openTimeTracking}
      />
      <Modal open={openTimeTracking} onClose={() => setOpenTimeTracking(false)}>
        <Box sx={{ ...modalStyle, width: 440 }}>
          <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
            จัดการลงเวลา
          </Typography>
          {!timeTrackingEnabled && (
            <Alert severity="warning" sx={{ mb: 1.5, py: 0 }}>
              ปิดการลงเวลาผ่าน Profile
            </Alert>
          )}
          <FormControlLabel
            control={
              <Switch
                checked={timeTrackingEnabled}
                onChange={(e) => handleToggleTimeTracking(e.target.checked)}
                color="success"
                size="small"
              />
            }
            label="ลงเวลาผ่านหน้า Profile"
          />
          <Divider sx={{ my: 1.5 }} />
          <FormControlLabel
            control={
              <Switch
                checked={timeTrackingLinkEnabled}
                onChange={(e) => handleToggleTimeTrackingLink(e.target.checked)}
                color="primary"
                size="small"
              />
            }
            label="ลงเวลาผ่านลิงก์ Manpower"
          />
          {timeTrackingLinkEnabled && (
            <>
              <Divider sx={{ my: 1.5 }} />
              <TextField
                value={link}
                fullWidth
                size="small"
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => navigator.clipboard.writeText(link)}
                      >
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </>
          )}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button size="small" onClick={() => setOpenTimeTracking(false)}>
              ปิด
            </Button>
          </Box>
        </Box>
      </Modal>

      <CSVUploadModal
        csvData={csvData}
        setCsvData={setCsvData}
        fileTemplateURL="/filetemplate/budget_template.csv"
        handleAddFromFile={handleAddFromFile}
        handleClose={() => {
          setCsvUploadOpen(false);
          setCsvData([]);
        }}
        isOpen={csvUploadOpen}
        titleName="รายการงบประมาณจากไฟล์ CSV"
        header={0}
        anotherComponent={<div />}
      />
    </Box>
  );
}
